import React, { ReactElement, FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Card, Typography } from 'antd'
import { MailOutlined, PhoneOutlined } from '@ant-design/icons'
import { ProposalCard } from '../ProposalCard'
import { s } from './style'
import {
  RequestedProposalEventFragment,
  RequestedProposalProposalFragment,
} from './RequestedProposal.generated-types'

const { Link, Text } = Typography

interface RequestedResponseProps {
  event: RequestedProposalEventFragment
  proposal: RequestedProposalProposalFragment
}

export const RequestedProposal: FC<RequestedResponseProps> = ({
  event,
  proposal,
  proposal: {
    space: {
      hostContact: { email, phoneNumber },
    },
  },
}): ReactElement => {
  const { t } = useTranslation()

  return (
    <div style={s.root}>
      <ProposalCard event={event} proposal={proposal} />
      {email && phoneNumber && (
        <Card bodyStyle={s.card}>
          <Avatar size={54} />
          <div style={s.column}>
            <Text strong style={{ fontSize: 18 }}>
              {t('eventHub.inProgress.requested.inTouch', 'Get in touch')}
            </Text>
            <div style={s.row}>
              <MailOutlined />
              <Link style={s.text}>{email}</Link>
              <PhoneOutlined style={s.icon} />
              <Text style={s.text}>{phoneNumber}</Text>
            </div>
          </div>
        </Card>
      )}
    </div>
  )
}
